<div class="main-container">
  <div class="main-line line-1"></div>
  <div class="main-line line-2"></div>
  <div class="main-line line-3"></div>
  <div class="main-line line-3-1"></div>
  <div class="main-line line-3-2"></div>
  <div class="main-line line-3-3"></div>
  <div class="main-line line-2-1"></div>
  <div class="main-line line-4"></div>

  <ng-container *ngFor="let item of topItems">
    <div [ngClass]="item.className">
      <wlm-water-balance-item-input
        [i18Key]="item.i18Key"
        [color]="colors[item.index] || defaultColor"
        (colorChange)="onColorChange(item.index, $event)"
      ></wlm-water-balance-item-input>
    </div>
  </ng-container>

  <div class="second-group">
    <div class="input-groups-right">
      <ng-container *ngFor="let item of secondGroupItems">
        <div [ngClass]="item.className">
          <wlm-water-balance-item-input
            [i18Key]="item.i18Key"
            [color]="colors[item.index] || defaultColor"
            (colorChange)="onColorChange(item.index, $event)"
          ></wlm-water-balance-item-input>
        </div>
      </ng-container>
    </div>
    <div class="right-block"></div>
  </div>

  <ng-container *ngFor="let item of bottomItems">
    <div [ngClass]="item.className">
      <wlm-water-balance-item-input
        [i18Key]="item.i18Key"
        [color]="colors[item.index] || defaultColor"
        (colorChange)="onColorChange(item.index, $event)"
      ></wlm-water-balance-item-input>
    </div>
  </ng-container>
</div>
